<template>
  <DashboardPanel class="chart-card" :title="title" :subtitle="subtitle" :icon="icon">
    <template #actions>
      <span v-if="pill" class="range-pill" :class="pillTone">{{ pill }}</span>
    </template>
    <apexchart v-if="hasData" :type="type" :height="height" :options="options" :series="series" />
    <div v-else class="empty-state">{{ emptyText }}</div>
  </DashboardPanel>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";

// A panel showing one chart, or an empty-state message when there is no data.
export default {
  name: "ChartCard",
  components: { DashboardPanel },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    pill: { type: String, default: "" },
    pillTone: { type: String, default: "" },
    type: { type: String, required: true },
    height: { type: String, required: true },
    options: { type: Object, required: true },
    series: { type: Array, required: true },
    hasData: { type: Boolean, default: true },
    emptyText: { type: String, default: "No data yet." },
  },
};
</script>
